// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YQBwX","content":"styles_content__z-Cix","tableWrap":"styles_tableWrap__3Jp4f"};